import { Controller } from "@hotwired/stimulus"

// Autocomplete dla klubu przy edycji użytkownika.
// Gdy użytkownik wybierze klub z listy — ustawiamy club_id.
// Gdy wpisze tekst bez wyboru — zostawiamy string jako club_name (bez powiązania).
export default class extends Controller {
  static targets = ["input", "results", "clubIdInput"]
  static values = {
    url: String
  }

  connect() {
    this.timeout = null
    document.addEventListener("click", this._handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this._handleClickOutside)
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this._hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this._fetchClubs(query)
    }, 250)
  }

  select(event) {
    event.preventDefault()
    this._selecting = true
    const club = JSON.parse(event.currentTarget.dataset.club)
    this.inputTarget.value = club.city ? `${club.name} (${club.city})` : club.name
    if (this.hasClubIdInputTarget) {
      this.clubIdInputTarget.value = club.id
    }
    this._hideResults()
    this._selecting = false
  }

  onInput() {
    // Gdy użytkownik edytuje tekst ręcznie — czyścimy club_id (zostaje wolny tekst)
    if (!this._selecting && this.hasClubIdInputTarget) {
      this.clubIdInputTarget.value = ""
    }
  }

  async _fetchClubs(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Server error")

      const clubs = await response.json()
      this._renderResults(clubs)
    } catch (error) {
      console.error("Error fetching clubs:", error)
      this._hideResults()
    }
  }

  _renderResults(clubs) {
    if (clubs.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="sc-autocomplete-item text-center text-muted small py-2">
          Nie znaleziono klubów — wpisany tekst zostanie zachowany jako nazwa
        </div>
      `
    } else {
      this.resultsTarget.innerHTML = clubs.map(club => {
        return `
          <div class="sc-autocomplete-item"
               data-action="click->club-autocomplete#select"
               data-club='${JSON.stringify(club).replace(/'/g, "&#39;")}'>
            <span class="sc-autocomplete-name">${club.name}</span>
            ${club.city ? `<span class="text-muted ms-2">${club.city}</span>` : ""}
          </div>
        `
      }).join("")
    }

    this.resultsTarget.classList.remove("uk-hidden", "d-none")
  }

  _hideResults() {
    this.resultsTarget.classList.add("uk-hidden", "d-none")
    this.resultsTarget.innerHTML = ""
  }

  _handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._hideResults()
    }
  }
}
